<template>
  <div>
    <sj-dropdown class="test" placement="bottom" trigger="click" appendToBody>
      <span slot="reference">点击触发</span>
      <div slot="dropdown">
        <div style="padding: 10px;">dropdown示例内容</div>
      </div>
    </sj-dropdown>
    <sj-dropdown
      class="test"
      placement="bottom"
      :closeOnClick="false"
      trigger="hover"
    >
      <span slot="reference">悬浮触发</span>
      <div slot="dropdown">
        <div style="padding: 10px;">dropdown示例内容</div>
      </div>
    </sj-dropdown>
    <sj-dropdown class="test" placement="bottom" trigger="hover">
      <span
        slot="reference"
        style="display:inline-block;padding: 30px;border: 1px solid #606266"
        >悬浮触发</span
      >
      <div slot="dropdown">
        <div style="padding: 10px;">dropdown示例内容</div>
      </div>
    </sj-dropdown>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="less">
.test {
  margin: 10px;
}
</style>
